export default __webpack_public_path__ + "static/media/6.8ee84e72.jpg";